import {takeEvery} from 'redux-saga/effects'
import {GET_ACTM_ACCOUNT_SETTING_BY_BRANCH_ID} from 'setup/redux/Actions/ActmAccountSetting/ActionTypes/ApiActionTypes'

import fetchData from '../../SagaHelper'

function* dataSaga() {
  yield takeEvery(GET_ACTM_ACCOUNT_SETTING_BY_BRANCH_ID, fetchData)
}

export default dataSaga
